import axios from '../api/axios'

export const TYPES = {
  USER_LOGOUT: 'USER_LOGOUT',
  USER_LOGIN: 'USER_LOGIN',
  SET_LOGIN_MESSAGE: 'SET_LOGIN_MESSAGE',
  DEL_LOGIN_MESSAGE: 'DEL_LOGIN_MESSAGE',
  GET_REQUESTERS: 'GET_REQUESTERS',
  GET_ADDRESSES: 'GET_ADDRESSES',
  GET_ME: 'GET_ME',
  PASSWORD_RESET: 'PASSWORD_RESET'
}

export function delLoginMessage() {
  return dispatch => dispatch({ type: TYPES.DEL_LOGIN_MESSAGE })
}

export function loginUser({ username, password }) {
  return async dispatch => {
    const options = {
      method: 'post',
      url: '/api/auth/login',
      data: {
        username,
        password
      }
    }

    const type = TYPES.USER_LOGIN
    const { data } = await axios(options, dispatch, type)
    if (data.message) {
      dispatch({ type: TYPES.SET_LOGIN_MESSAGE, payload: data.message })
    } else {
      localStorage.Auth = data.token
      dispatch({ type, payload: data })
      getMe()(dispatch)
    }
  }
}

export function logoutUser() {
  const type = TYPES.USER_LOGOUT
  localStorage.removeItem('Auth')
  return dispatch => dispatch({ type })
}

export function setUserDetailProp(prop, val) {
  return async dispatch => {
    dispatch({ type: TYPES.SET_USER_DETAIL_PROP, payload: { [prop]: val } })
  }
}

export function getMe() {
  return async dispatch => {
    const options = {
      method: 'get',
      url: '/api/user/me',
      params: {}
    }

    const type = TYPES.GET_ME
    const { data } = await axios(options, dispatch, type)
    dispatch({ type, payload: data })
  }
}

export function passwordReset({ id, password, newPassword }) {
  return async dispatch => {
    const options = {
      method: 'post',
      url: '/api/auth/password-reset',
      data: {
        id,
        password,
        newPassword
      }
    }

    const type = TYPES.PASSWORD_RESET
    const { data } = await axios(options, dispatch, type)
    if (!data.message) {
      dispatch({ type, payload: data })
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js